var map = {
	"./arcan_small.jpeg": 58551,
	"./bazaar_small.jpeg": 42919,
	"./cosmo_small.jpeg": 97055,
	"./esquire_small.jpeg": 87800,
	"./girlspower_small.jpeg": 32484,
	"./goodhouse_small.jpeg": 36787,
	"./grazia_small.jpeg": 33600,
	"./im_small.jpeg": 46382,
	"./mhealth_small.jpeg": 47045,
	"./popmech_small.jpeg": 6542,
	"./robb_small.jpeg": 68075,
	"./vslova_small.jpeg": 55995
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 12163;